import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, Paper, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { checkPaymentStatus } from '../services/payment';
import { useAuth } from '../context/AuthContext';

const PaymentResultPage = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();
  const [state, setState] = useState('checking');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        for (let attempt = 0; attempt < 5; attempt += 1) {
          const payment = await checkPaymentStatus(paymentId);
          if (cancelled) return;
          if (payment.status === 'success') { await refreshProfile(); setState('success'); return; }
          if (payment.status === 'CANCEL' || payment.status === 'cancel') { setState('cancelled'); return; }
          if (attempt < 4) await new Promise((resolve) => setTimeout(resolve, 3000));
        }
        setState('pending');
      } catch (err) {
        if (!cancelled) { setError(err.response?.data?.detail || 'Не удалось проверить платёж'); setState('error'); }
      }
    };
    check();
    return () => { cancelled = true; };
  }, [paymentId, refreshProfile]);

  const content = {
    success: ['Баланс пополнен', 'Платёж подтверждён, средства уже доступны в кабинете.'],
    pending: ['Платёж обрабатывается', 'Подтверждение может занять несколько минут. Вернитесь в кабинет и обновите данные позже.'],
    cancelled: ['Платёж отменён', 'Средства не были списаны. Вы можете создать новый платёж в кабинете.'],
    error: ['Не удалось проверить платёж', error],
  }[state];

  return <Box className="noise-bg" minHeight="100vh" display="grid" sx={{ placeItems: 'center' }}><Container maxWidth="sm"><Paper sx={{ p: 5, textAlign: 'center' }}>
    {state === 'checking' ? <><CircularProgress sx={{ mb: 3 }}/><Typography variant="h5">Проверяем платёж…</Typography></> : <Stack spacing={3} alignItems="center"><Typography variant="h4">{content[0]}</Typography><Alert severity={state === 'success' ? 'success' : state === 'error' ? 'error' : 'info'}>{content[1]}</Alert><Button variant="contained" onClick={() => navigate('/dashboard')}>Вернуться в кабинет</Button></Stack>}
  </Paper></Container></Box>;
};

export default PaymentResultPage;
